import { useSnackbar } from "notistack";
import { useCallback, ReactNode } from "react";
import Toast, { ToastProps } from "../../Components/Misc/Toast/toast";

const useCustomSnackbar = () => {
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();

  const enqueueCustomSnackbar = useCallback(
    (
      message: string,
      type: ToastProps["type"],
      persist: boolean = false,
      rightContent?: ReactNode,
      body?: string | null
    ) => {
      enqueueSnackbar(message, {
        autoHideDuration: 6500,
        persist: persist,
        anchorOrigin: { vertical: "bottom", horizontal: "right" },
        disableWindowBlurListener: true,
        content: (key, message) => (
          <Toast
            type={type}
            title={message?.toString()}
            body={body}
            rightContent={rightContent}
            onClose={() => closeSnackbar(key)}
          />
        ),
      });
    },
    [enqueueSnackbar, closeSnackbar]
  );

  return enqueueCustomSnackbar;
};

export default useCustomSnackbar;
